// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatElement.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  require('share/utils/Izenda.StringUtilities');

  var m = require('mobx');
  require('share/utils/Izenda.StringUtilities');
  var trackable = require('share/tracking/Izenda.Trackable');
  var ReportFormatDetails = require('./Izenda.ReportFormatDetails');
  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var DEFAULT_WIDTH_HEIGHT = 1;
  var GridLayoutUtils = require('share/utils/Izenda.GridLayoutUtils')(
    CONSTANTS.NUMBER_HEADER_COLS,
    DEFAULT_WIDTH_HEIGHT,
    DEFAULT_WIDTH_HEIGHT
  );
  var ITEMS_TYPE = CONSTANTS.ITEMS_TYPE;

  const { map, forEach, uniqueId, get, filter, every } = require('lodash/fp');

  function ReportFormatElement(name, data) {
    var props = {
      name: name,
      formatItems: [],
      hasSelectedItem: function() {
        return !every(['isSelected', false], this.formatItems);
      }
    };

    m.extendObservable(trackable(this), props);

    this.populateData(data);

    this.cleanDirty();
  }

  /**
   * Populate format element from report format element data.
   * @param {Array} An array of report format element
   */
  ReportFormatElement.prototype.populateData = m.action(function(data) {
    data &&
      this.formatItems.replace(
        map(function(item) {
          return new ReportFormatDetails(item);
        }, data)
      );
  });

  /**
   * Get format items
   * @returns {Array}
   */
  ReportFormatElement.prototype.getItems = function() {
    return this.formatItems;
  };

  /**
   * Init default layout for report header
   * This is used when initialize report
   * @param {object} data
   */
  ReportFormatElement.prototype.initDefaultLayout = m.action(function() {
    var data = CONSTANTS[this.name];
    var defaultItems = Object.keys(data).map(function(key) {
      return new ReportFormatDetails(data[key]);
    });
    this.formatItems.replace(defaultItems);
  });

  /**
   * Add new format item
   * @param {string} type
   * @param {string} width
   * @param {string} height
   */
  ReportFormatElement.prototype.addItem = m.action(function(type, width, height) {
    var item = ITEMS_TYPE[type];
    var length = this.formatItems.length;
    var dims = GridLayoutUtils.getAvaiablePosition(this.formatItems, width, height);
    var listItemsByType = filter({ type: type }, this.formatItems);
    var itemName = String.generateNewName(item.defaultName, listItemsByType, get('name'));

    width = item.width || width;
    height = item.height || height;

    var part = {
      id: uniqueId('reportFormatItems_'),
      type: type,
      label: item.label,
      positionX: dims.positionX,
      positionY: dims.positionY,
      width: dims.width,
      height: dims.height,
      name: itemName,
      value: item.defaultValue,
      minHeight: item.minHeight
    };

    var formatItemDetail = new ReportFormatDetails(part);
    this.formatItems.splice(length, 0, formatItemDetail);

    this.markDirty();
  });

  /**
   * Get dirty status
   * @returns {boolean}
   */
  ReportFormatElement.prototype.checkDirty = function() {
    var formatItems = this.formatItems;
    if (!this.isDirty) {
      for (var i = 0; i < formatItems.length; i++) {
        if (formatItems[i].isDirty) {
          return true;
        }
      }
    }
    return this.isDirty;
  };

  /**
   * Clean Dirty
   */
  ReportFormatElement.prototype.cleanDirty = m.action(function() {
    var formatItems = this.formatItems;
    forEach(
      m.action(function(item) {
        item.resetDirty();
      }),
      formatItems
    );

    return this.resetDirty();
  });

  /**
   * Reset selected item
   */
  ReportFormatElement.prototype.checkExistingFormatItemName = function(newName, exceptItem) {
    var names = map(get('name'), this.formatItems);

    var index = names.indexOf(newName);

    if (index >= 0) {
      names.splice(index, 1);
      return String.checkDuplicate(newName, names);
    }

    return false;
  };

  module.exports = ReportFormatElement;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportFormatElement.js